/** Shared church calendar events – used by the month calendar and home Upcoming Events list */

export const CHURCH_EVENTS = [
  {
    id: 'convention-2026',
    title: 'Annual Convention',
    start: '2026-09-25',
    end: '2026-09-27',
    color: '#9f1a26',
    highlight: true,
    detailLines: [
      'Sep 25 (Fri), Sep 26 (Sat), Sep 27 (Sun)',
      'Each evening at 6:30 PM',
      'Theme: The Second Coming of Jesus Christ & the End of the World',
      'Guest Speaker: Anil Kodithottam',
      '2840 Holme Ave, Philadelphia, PA 19152',
    ],
  },
  {
    id: 'picnic',
    title: 'Church Picnic',
    start: '2026-06-27',
    end: '2026-06-27',
    color: '#c01f2d',
    highlight: true,
    detailLines: [
      'Church Picnic: 8:00 AM – 6:00 PM',
      'Off-site — contact us for location',
    ],
  },
  {
    id: 'tuesday-prayer',
    title: 'Tuesday Prayer',
    recurrence: 'weekly',
    weekday: 2,
    color: '#2563eb',
    detailLines: [
      'Prayer Meeting: 8:00 PM',
      '(Online)',
    ],
  },
  {
    id: 'youth-ca',
    title: 'Youth Meeting (CA)',
    recurrence: 'lastSunday',
    color: '#7c3aed',
    detailLines: [
      'Youth Meeting (CA)',
      '(In-Person @ Church)',
    ],
  },
  {
    id: 'saturday-prayer',
    title: 'Saturday Prayer',
    recurrence: 'weekly',
    weekday: 6,
    color: '#059669',
    detailLines: [
      'Prayer Meeting: 6:30 PM',
      '(In-Person @ Church)',
    ],
  },
  {
    id: 'ladies',
    title: "Ladies' Meeting",
    recurrence: 'secondWeekday',
    weekday: 2,
    color: '#db2777',
    detailLines: [
      "Ladies' Meeting: 7:00 PM",
      '(Online)',
    ],
  },
];

/**
 * Sidebar cards – names, times, and locations aligned with the calendar (no schedule phrases).
 * `until` is the last date a one-off event stays in the list; recurring events omit it.
 */
export const UPCOMING_EVENT_CARDS = [
  {
    id: 'convention-2026',
    name: 'Annual Convention',
    time: 'Sep 25–27 • 6:30 PM',
    location: '2840 Holme Ave, Philadelphia, PA 19152',
    until: '2026-09-27',
  },
  {
    id: 'tuesday-prayer',
    name: 'Tuesday Prayer',
    time: '8:00 PM',
    location: '(Online)',
  },
  {
    id: 'saturday-prayer',
    name: 'Saturday Prayer',
    time: '6:30 PM',
    location: '(In-Person @ Church)',
  },
  {
    id: 'ladies',
    name: "Ladies' Meeting",
    time: '7:00 PM',
    location: '(Online)',
  },
  {
    id: 'youth-ca',
    name: 'Youth Meeting (CA)',
    time: null,
    location: '(In-Person @ Church)',
  },
  {
    id: 'fasting',
    name: 'Fasting Prayer Week',
    time: null,
    location: '(In-Person @ Church)',
  },
  {
    id: 'picnic',
    name: 'Church Picnic',
    time: '8:00 AM – 6:00 PM',
    location: 'Contact us for location',
    until: '2026-06-27',
  },
];
